/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @version 1.0.0
 * @since 1.0.0
 */

import { ISuperSearchTranslation } from '../../../internationalization/types/corporate';
import {
    SuperSearchListGroupStyled,
    SuperSearchListItemStub,
} from '../styled/SuperSearchListStyled';

export interface ISuperSearchItemEmptyProps {
    translation: ISuperSearchTranslation;
}

const SuperSearchItemEmpty = ({ translation }: ISuperSearchItemEmptyProps) => {
    return (
        <SuperSearchListGroupStyled>
            <SuperSearchListItemStub>
                {translation.notFound}
            </SuperSearchListItemStub>
        </SuperSearchListGroupStyled>
    );
};

export default SuperSearchItemEmpty;
